var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrightness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 92 92",
    enableBackground: "new 0 0 92 92",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1844_",
    d: "M46,23.7c-12.3,0-22.3,10-22.3,22.3s10,22.3,22.3,22.3s22.3-10,22.3-22.3S58.3,23.7,46,23.7z M46,60.3 c-7.9,0-14.3-6.4-14.3-14.3S38.1,31.7,46,31.7S60.3,38.1,60.3,46S53.9,60.3,46,60.3z M42,12.3V4c0-2.2,1.8-4,4-4s4,1.8,4,4v8.3 c0,2.2-1.8,4-4,4S42,14.5,42,12.3z M92,46c0,2.2-1.8,4-4,4h-8.3c-2.2,0-4-1.8-4-4s1.8-4,4-4H88C90.2,42,92,43.8,92,46z M50,79.7V88 c0,2.2-1.8,4-4,4s-4-1.8-4-4v-8.3c0-2.2,1.8-4,4-4S50,77.5,50,79.7z M12.3,50H4c-2.2,0-4-1.8-4-4s1.8-4,4-4h8.3c2.2,0,4,1.8,4,4 S14.5,50,12.3,50z M67,25c-1.6-1.6-1.6-4.1,0-5.7l5.8-5.8c1.6-1.6,4.1-1.6,5.7,0c1.6,1.6,1.6,4.1,0,5.7L72.7,25 c-0.8,0.8-1.8,1.2-2.8,1.2S67.8,25.8,67,25z M78.5,72.9c1.6,1.6,1.6,4.1,0,5.7c-0.8,0.8-1.8,1.2-2.8,1.2s-2-0.4-2.8-1.2L67,72.7 c-1.6-1.6-1.6-4.1,0-5.7c1.6-1.6,4.1-1.6,5.7,0L78.5,72.9z M25,67c1.6,1.6,1.6,4.1,0,5.7l-5.8,5.8c-0.8,0.8-1.8,1.2-2.8,1.2 s-2-0.4-2.8-1.2c-1.6-1.6-1.6-4.1,0-5.7l5.8-5.8C20.9,65.5,23.4,65.5,25,67z M13.5,19.1c-1.6-1.6-1.6-4.1,0-5.7 c1.6-1.6,4.1-1.6,5.7,0l5.8,5.8c1.6,1.6,1.6,4.1,0,5.7c-0.8,0.8-1.8,1.2-2.8,1.2c-1,0-2-0.4-2.8-1.2L13.5,19.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightness);
export default __webpack_public_path__ + "static/media/brightness.1806b9b975de3fcf4df8b3f959f5946f.svg";
export { ForwardRef as ReactComponent };